import { createContext } from 'react';
import { TKeyEditorProvider } from './KeyEditorProvider';

const emptyDefinition = {
  fields: { key: [], compare: [], display: [] },
  data_frames: {
    left: {
      path: '',
      version: '',
    },
    right: {
      path: '',
      version: '',
    },
  },
};

export const KeyEditorContext = createContext<TKeyEditorProvider>({
  compare: emptyDefinition,
  associations: [],
  unLinkedFields: [],
  selectedFields: [],
  leftFields: [],
  rightFields: [],
  mergedFields: [],
  compiledDefinition: emptyDefinition,
  toggleKeyField: () => {},
  toggleTargetField: () => {},
  isValid: false,
  reset: () => {},
  isDirty: false,
  errorMessages: [],
  canEdit: false,
});
